/**
 * The wishlist integrations JS functionality.
 */

class qalaWishlist {
	constructor() {
		wp.hooks.addAction( 'qalaBuy.action.after_quickview_populated', 'addQalaWishlist', this.addWishlist );
		wp.hooks.addFilter( 'qala_wishlist.filter.container_classes', 'addQuickviewContainerClass', this.addQuickviewContainerClass );
	}

	/**
	 * Populates the wishlist template with the content.
	 *
	 * @param {Object} productData
	 * @param {Object} quickview
	 */
	addWishlist = ( productData, quickview ) => {
		// Bail early if we don't have the button.
		if ( ! productData.wishlist_button ) {
			return;
		}

		// Set up the wishlist!
		const wrapper = quickview.modal.querySelector( '.qala-quickview__wishlist' );
		if ( ! wrapper ) {
			return;
		}
		const wishlistTemplate = wp.template( 'quickview-wishlist-button' );
		wrapper.innerHTML = wishlistTemplate( productData );
	};

	/**
	 * Adds our quickviews footer to the elements that should be checked for wishlist triggers.
	 *
	 * @param {Array} containers The array of targets
	 */
	addQuickviewContainerClass = containers => {
		return [ ...containers, '.qala-quickview__footer' ];
	};
}

export default qalaWishlist;
